<div class="flex items-center justify-center gap-2.5 lg:justify-start">
  <app-avatar [name]="name()" [source]="source()" [isLoading]="isLoading()" class="hidden lg:block" />
  <div class="space-y-1">
    @if (isLoading()) {
      <div class="kt-skeleton w-32 h-4"></div>
      <div class="kt-skeleton w-20 h-3"></div>
    } @else {
      <h3 class="text-sm text-gray-900 font-medium leading-tight text-center lg:text-start">
        {{ name() }}
      </h3>
      <p class="text-center text-xs text-gray-700 leading-tight lg:text-left">
        {{ document() }}
      </p>
    }
  </div>
</div>
